
// 项目code
export function getProjectCode() {
  return '7d44b9fe934ff3daded0180fdf3a20bb'
}


// 设置当前项目code
export function setProjectCode() {
  window.localStorage.setItem('PLATFORM_CODE', getProjectCode())
}




// WEBPACK FOOTER //
// ./src/utils/code.js